export const identifyEmployer = async (currentUser, companyDetails, productPlan) => {
  analytics.identify(currentUser.id, {
    user_type: 'member',
    name: currentUser.name,
    email: currentUser.email,
    createdAt: currentUser.created_at,
    company: companyDetails
      ? {
          id: companyDetails.id,
          name: companyDetails.name,
          created_at: companyDetails.created_at,
        }
      : undefined,
    state: companyDetails?.current_state,
    productPlan,
  })
}
